import { ThemeUICSSObject } from 'theme-ui';

export const switchBase: ThemeUICSSObject = {
  'input[type="checkbox"]': {
    position: 'absolute',
    transform: 'translateX(-9999px)',
  },
};
